
import Vue, { PropType } from 'vue'
import GoToButtonLink from '@/components/modals/GoToButtonLink.vue'
import { RIcon } from '@/components'
import OfferCard from '@/components/onboarding/OnboardingOfferCard.vue'
import { getIconUrl } from '@/services/url'
import { mapGetters } from 'vuex'

export default Vue.extend({
  components: {
    GoToButtonLink,
    OfferCard,
    RIcon,
  },
  props: {
    variant: {
      type: String as PropType<'mobile' | 'desktop'>,
      default: 'mobile',
    },
    hadPayment: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iconSize(): number {
      switch (this.variant) {
        case 'desktop':
          return 30
        default:
          return 20
      }
    },
    getCheckmarkURL(): string {
      return getIconUrl() + 'leakyCheckmark.svg'
    },
    title(): string {
      return this.hadPayment ? 'Payment confirmed' : 'Almost ready'
    },
    ...mapGetters({
      userStripeId: 'user/userStripeCustomerId',
    }),
  },
})
